import { MacroRegion } from "../../enum/MacroRegion";
import { macroRegionLimits } from "./macroRegionLimits";
import { validatePointInsidePolygon } from "util/validadePointInsidePolygon/validatePointInsidePolygon";
import { IMacroRegion } from "types/IMacroRegion";

/**
 * Determines which macro region a single point belongs to.
 * Unlike getMacroRegionOriginFromPolygon, this function works with
 * a single lat/lng coordinate instead of a polygon.
 */
export const getMacroRegionOriginFromPoint = (
    lat: number,
    lng: number,
    companyMacroRegions: IMacroRegion[],
    userMacroRegions: MacroRegion[] = []
): MacroRegion | null => {
    const point = [lng, lat]; // GeoJSON format: [longitude, latitude]

    const companyMacroRegionOrigins = companyMacroRegions?.map(
        (macroRegion) => macroRegion.origin
    );

    for (const regionKey in macroRegionLimits) {
        if (
            companyMacroRegionOrigins &&
            !companyMacroRegionOrigins.includes(regionKey)
        ) {
            continue;
        }

        if (
            userMacroRegions.length &&
            !userMacroRegions.includes(regionKey as MacroRegion)
        ) {
            continue;
        }

        const regionPolygons = macroRegionLimits[regionKey];
        const isInside = validatePointInsidePolygon(point, regionPolygons);

        if (isInside) {
            return regionKey as MacroRegion;
        }
    }

    return null;
};
